export const staticStrings = {
  logout: 'Logout',
  welcomeTo: 'Welcome to Operations Portal',
  enterLoginCreds: 'Enter Login Credentials',
  userName: 'User Name',
  integration: 'OPERATIONS PORTAL',
  userPlaceholder: 'Enter UserName',
  password: 'Password',
  otp: 'OTP',
  enterPassword: 'Enter your Password',
  login: 'Login',
  sendOtp: 'Send OTP',
}
export const stateGstMap: any = {
  AD: '37',
  AR: '12',
  AS: '18',
  BR: '10',
  CG: '22',
  DL: '07',
  GA: '30',
  GJ: '24',
  HR: '06',
  HP: '02',
  JK: '01',
  JH: '20',
  KA: '29',
  KL: '32',
  LD: '31',
  MP: '23',
  MH: '27',
  MN: '14',
  ML: '17',
  MZ: '15',
  NL: '13',
  OD: '21',
  PY: '34',
  PB: '03',
  RJ: '08',
  SK: '11',
  TN: '33',
  TS: '36',
  TR: '16',
  UP: '09',
  UK: '05',
  WB: '19',
  AN: '35',
  CH: '04',
  DNHDD: '26',
  LA: '38',
  OT: '97',
}
export const stateCodeMap: any = {
  'Andaman and Nicobar Islands': 'AN',
  // 'Andhra Pradesh': 'AP',
  'Andhra Pradesh': 'AD',
  'Arunachal Pradesh': 'AR',
  Assam: 'AS',
  Bihar: 'BH',
  Chandigarh: 'CH',
  Chattisgarh: 'CT',
  'Dadra and Nagar Haveli': 'DN',
  'Daman and Diu': 'DD',
  Delhi: 'DL',
  Goa: 'GA',
  Gujarat: 'GJ',
  Haryana: 'HR',
  'Himachal Pradesh': 'HP',
  'Jammu and Kashmir': 'JK',
  Jharkhand: 'JH',
  Karnataka: 'KA',
  Kerala: 'KL',
  'Lakshadweep Islands': 'LD',
  'Madhya Pradesh': 'MP',
  Maharashtra: 'MH',
  Manipur: 'MN',
  Meghalaya: 'ME',
  Mizoram: 'MI',
  Nagaland: 'NL',
  Odisha: 'OR',
  Pondicherry: 'PY',
  Punjab: 'PB',
  Rajasthan: 'RJ',
  Sikkim: 'SK',
  'Tamil Nadu': 'TN',
  Telangana: 'TS',
  Tripura: 'TR',
  'Uttar Pradesh': 'UP',
  Uttarakhand: 'UT',
  'West Bengal': 'WB',
  'Other Territory': 'OT',
  Ladakh: 'LA',
  'Dadra & Nagar Haveli and Daman & Diu': 'DNHDD',
}

export const entityHeader = {
  id: '0',
  action: 'Entity Id',
  name: 'Name',
  type: 'Type',
  status: 'Status',
  netbanking: 'Supporting Netbanking',
  card: 'Supporting Card',
}

export const entityData = [
  {
    id: '1',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    supportNetBanking: 'Yes',
    supportCard: 'No',
  },
  {
    id: '2',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    supportNetBanking: 'Yes',
    supportCard: 'No',
  },
  {
    id: '3',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    supportNetBanking: 'Yes',
    supportCard: 'No',
  },
]

export const statusData = [
  { id: 1, value: 'Enable' },
  { id: 2, value: 'Disable' },
]

export const cardMHeader = {
  expand: '',
  id: '0',
  entityId: 'Entity ID',
  scheme: 'Scheme',
  cardType: 'Cardtype',
  status: 'Status',
}

export const cardData = [
  {
    expand: '',
    id: '1',
    entityId: 'Entity ID',
    scheme: 'Scheme',
    cardType: 'Cardtype',
    status: 'Status',
  },
  {
    expand: '',
    id: '2',
    entityId: 'Entity ID',
    scheme: 'Scheme',
    cardType: 'Cardtype',
    status: 'Status',
  },
  {
    expand: '',
    id: '3',
    entityId: 'Entity ID',
    scheme: 'Scheme',
    cardType: 'Cardtype',
    status: 'Status',
  },
]

export const nbHeader = {
  expand: '',
  id: '0',
  entityId: 'Entity ID',
  entityCode: 'Entity Code',
  rpslCode: 'RPSL Code',
  bankName: 'Bank Name',
  status: 'Status',
}

export const nbData = [
  {
    expand: '',
    id: '1',
    entityId: 'Entity ID',
    entityCode: 'Entity Code',
    rpslCode: 'RPSL Code',
    bankName: 'Bank Name',
    status: 'Status',
  },
  {
    expand: '',
    id: '2',
    entityId: 'Entity ID',
    entityCode: 'Entity Code',
    rpslCode: 'RPSL Code',
    bankName: 'Bank Name',
    status: 'Status',
  },
  {
    expand: '',
    id: '3',
    entityId: 'Entity ID',
    entityCode: 'Entity Code',
    rpslCode: 'RPSL Code',
    bankName: 'Bank Name',
    status: 'Status',
  },
]

export const approvalHeader = {
  expand: '',
  id: '0',
  appovalId: 'ID',
  key: 'Key',
  username: 'Username',
  approvaltype: 'Approval Type',
}

export const approvalData = [
  {
    expand: '',
    id: '1',
    appovalId: 'ID',
    key: 'Key',
    username: 'Username',
    approvaltype: 'UPADTE_APPROVAL',
  },
  {
    expand: '',
    id: '2',
    appovalId: 'ID',
    key: 'Key',
    username: 'Username',
    approvaltype: 'Approval Type',
  },
]

export const ApprovalTypes = {
  ENTITY: 'ENTITY',
  CARDMAPPING: 'CARDMAPPING',
  NETBANKING: 'NETBANKING',
  MERCHANT: 'MERCHANT',
  ROUTING: 'ROUTING',
  FILE_ROUTING: 'FILE_ROUTING',
  PACKAGE: 'PACKAGE',
  PACKAGE_INSTRUMENT: 'PACKAGE_INSTRUMENT',
  PACKAGE_MID: 'PACKAGE_MID',
  DYNAMIC_ROUTING: 'DYNAMIC_ROUTING',
  BANKING_CODE: 'BANKING_CODE',
  GENERATE_EXCEL_FILE: 'GENERATE_EXCEL_FILE',
  FEE_PACKAGE: 'FEE_PACKAGE',
  FEE_PACKAGE_FILE_UPLOAD: 'FILE_UPLOAD',
  FEE_PACKAGE_MID: 'FEE_PACKAGE_MID',
  MERCHANT_PAYOUT: 'MERCHANT_PAYOUT',
  CREDIT_ADJUSTMENT: 'CREDIT_ADJUSTMENT',
  RISK_CONFIG_MID: 'RISK_CONFIG_MID',
  RISK_CONFIG_TXNS: 'RISK_CONFIG_TXNS',
  PAYOUT_CMS: 'PAYOUT_CMS',

  ENTITY_MASTER_AUD_TRIAL: 'ENTITY_MASTER',
  ENTITY_CARD_AUD_TRIAL: 'ENTITY_CARD_MAPPING',
  ENTITY_NB_AUD_TRIAL: 'ENTITY_NB_MAPPING',

  MERCHANT_MAPPING_AUD_TRIAL: 'MERCHANT_MAPPING',

  ROUTING_RULE_AUD_TRIAL: 'ROUTING_RULE',
  FEE_PACKAGE_CONFIG_AUD_TRIAL: 'PACKAGE_CONFIG_1',
  FEE_MID_PACKAGE_CONFIG_AUD_TRIAL: 'MID_PACKAGE_CONFIG_1',

  ROUTING_PACKAGE_CONFIG_AUD_TRIAL: 'PACKAGE_CONFIG_0',
  ROUTING_MID_PACKAGE_CONFIG_AUD_TRIAL: 'MID_PACKAGE_CONFIG_0',

  EXTERNAL_ERROR_CONFIG_AUD_TRIAL: 'EXTERNAL_ERROR_CONFIG',
  PACKAGE_INST_CONFIG_AUD_TRIAL: 'PACKAGE_INST_CONFIG',
  RULE_PACKAGE_MAPPING_AUD_TRIAL: 'RULE_PACKAGE_MAPPING',
  BANKING_CODE_AUD_TRIAL: 'BANKING_CODE',
  ROUTING_FILE_UPLOAD_AUD_TRIAL: 'ROUTING_FILE_UPLOAD',
  MDR_PACKAGE_FILE_UPLOAD_AUD_TRIAL: 'MDR_PACKAGE_FILE_UPLOAD',
  PAYOUT_ENTITY_ACCOUNT_MAPPING_AUD_TRIAL: 'PAYOUT_ENTITY_ACCOUNT_MAPPING',
  PAYOUT_CONFIG_AUD_TRIAL: 'PAYOUT_CONFIG',
  POS_CONFIG_AUD_TRIAL: 'POS_CONFIG',

  //ESS - RISK Controls
  CRDR_ADJUSTMENT_AUD_TRIAL: 'CRDR_ADJUSTMENT',
  RISK_CONFIG_TXNS_AUD_TRIAL: 'ESS_RISK_TXN_CONTROLS',
  PAYOUT_CMS_AUD_TRIAL: 'ESS_PAYOUT_CMS',
  RISK_CONFIG_MID_AUD_TRIAL: 'ESS_RISK_MER_CONTROLS',
  ENTITYCONFIGURATION: 'ENTITYCONFIGURATION',
}

export const merchantHeader = {
  action: 'ID',
  id: '0',
  merchantID: 'Merchant ID',
  entityID: 'Entity ID',
  txnType: 'Txn Type',
  instrumentType: 'Instrument Type',
  pgMerchantID: 'PG Merchant ID',
  pgSecurityId: 'PG Security ID',
}

export const merchantData = [
  {
    action: '1',
    id: '1',
    merchantID: 'Merchant ID',
    entityID: 'Entity ID',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantID: 'PG Merchant ID',
    pgSecurityId: 'PG Security ID',
  },
  {
    action: '2',
    id: '2',
    merchantID: 'Merchant ID',
    entityID: 'Entity ID',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantID: 'PG Merchant ID',
    pgSecurityId: 'PG Security ID',
  },
  {
    action: '3',
    id: '3',
    merchantID: 'Merchant ID',
    entityID: 'Entity ID',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantID: 'PG Merchant ID',
    pgSecurityId: 'PG Security ID',
  },
]

export const staticRuleHeader = {
  expand: '',
  id: '0',
  ruleId: 'Rule Id',
  merchantId: 'Merchant Id',
  entityId: 'Entity Id',
  txnType: 'Txn Type',
  instrumentType: 'Instrument Type',
  pgMerchantId: 'PG Merchant ID',
  scheme: 'Scheme',
  bankId: 'Bank ID',
}

export const staticRuleData = [
  {
    expand: '',
    id: '1',
    ruleId: 'Rule Id',
    merchantId: 'Merchant Id',
    entityId: 'Entity Id',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantId: 'PG Merchant ID',
    scheme: 'Scheme',
    bankId: 'Bank ID',
  },
  {
    expand: '',
    id: '2',
    ruleId: 'Rule Id',
    merchantId: 'Merchant Id',
    entityId: 'Entity Id',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantId: 'PG Merchant ID',
    scheme: 'Scheme',
    bankId: 'Bank ID',
  },
  {
    expand: '',
    id: '3',
    ruleId: 'Rule Id',
    merchantId: 'Merchant Id',
    entityId: 'Entity Id',
    txnType: 'Txn Type',
    instrumentType: 'Instrument Type',
    pgMerchantId: 'PG Merchant ID',
    scheme: 'Scheme',
    bankId: 'Bank ID',
  },
]

type schemaType = {
  [key: string]: string
}

export const filterData = [
  { id: '1', value: '--Select All--' },
  { id: '2', value: 'Entity ID' },
  { id: '3', value: 'Merchant ID' },
]

export const CardSchema: schemaType = {
  '104': 'VISA',
  '105': 'MASTER',
  '199': 'RuPay',
  '107': 'Diners',
  '103': 'Amex',
  '133': 'CUP',
  '108': 'Discover',
  '106': 'EuroPay',
  '109': 'JCB',
  '120': 'DINA',
  '121': 'RPSL',
  '122': 'FDC',
}

export const CardTypes: schemaType = {
  '110': 'Debit',
  '130': 'Credit',
  '140': 'FoodCard',
}

export const InstrumentTypes: schemaType = {
  '523': 'FUNDS_TRANSFER_CREDIT',
  '524': 'FUNDS_TRANSFER_DEBIT',
  '525': 'CASH',
  '526': 'CREDIT',
  '527': 'DEBIT',
  '528': 'PURCHASE',
  '529': 'REFUND',
  '550': 'P2A',
  '551': 'P2U',
  '552': 'P2MOB',
  '554': 'REVERSAL',
  '560': 'UPI_PAY',
  '561': 'UPI_COLLECTION',
  '562': 'UPI_ACCEPT_REJECT',
  '563': 'UPI_BILL_PAY',
  '564': 'UPI_MERCHANT_PAY',
  '565': 'UPI_BILL_PAY_COLLECT',
  '566': 'UPI_MERCHANT_PAY_COLLECT',
  '553': 'BANK',
  '576': 'MANDATE',
  '575': 'WEBPAY',
  '580': 'UPI INSTRUMENT',
  '581': 'NET Banking',
  '582': 'Credit Card',
  '583': 'MANDATE_PAYER_CREATE',
  '584': 'MANDATE_PAYEE_CREATE',
  '585': 'MANDATE_PAYER _ACCEPT_REJECT​',
  '586': 'MANDATE_PAYER_BILLPAY_CREATE​',
  '587': 'MANDATE_PAYER_MERCHANT_CREATE',
  '588': 'MANDATE_PAYER_BILLPAY_REQUEST',
  '589': 'MANDATE_PAYER_MERCHANT_REQUEST',
  '568': 'UPI_INWARD_P2M',
  '569': 'UPI_INWARD_P2P',
  '590': 'MANDATE_CREATION',
  '579': 'WALLET/PPI INSTRUMENT',
}

export const TransactionType: schemaType = {
  '110': 'PURCHASE',
  '111': 'DEBIT',
  '112': 'DEBIT ADJUSTMENT',
  '113': 'CAPTURE',
  '211': 'REFUND',
  '212': 'MERCHANT CREDIT',
  '213': 'CREDIT',
  '214': 'CREDIT ADJUSTMENT',
  '215': 'CANCEL',
  '301': 'AUTH',
  '371': 'TRANSACTION CLOSURE',
  '302': 'REVERSAL',
  '420': 'IMPS',
  '421': 'NEFT',
  '422': 'RTGS',
  '423': 'FUNDS_TRNSFER',
  '470': 'UPI_P2P',
  '472': 'MANDATE_P2P',
  '473': 'MANDATE_P2M',
  '471': 'UPI_P2M',
  '306': 'SI INVOICE CREATION',
  '310': 'MANDATE_CREATION',
}

export const getSchema = (id: string) => {
  return `${id}-${CardSchema[id]}`
}

export const getCardType = (id: string) => {
  return `${id}-${CardTypes[id]}`
}

export const getIdNameValue = (id: string, data: any) => {
  return `${id}-${data[id]}`
}

export const getSchemaData = (data: any, type?: string) => {
  if (!data) {
    return []
  }
  const schema = Object.keys(data)?.map((value, index) => {
    return {
      id: value,
      value:
        type === 'sysControlConfig' || type === 'PACKAGE_CATEGORY' || type === 'SOURCE_ACC_CONFIG'
          ? data[value]
          : `${value}-${data[value]}`,
    }
  })
  return schema
}

export const statusMappingData = [
  { id: '1', value: 'Activate' },
  { id: '2', value: 'Deactivate' },
]

export const reqData = [{ id: '1', value: 'VALIDATE_EMI_PLAN' }]
type titleType = {
  [key: string]: string
}

export const ruleTitles: titleType = {
  all: '--Select All--',
  ruleId: 'Rule ID',
  ruleName: 'Rule Name',
  payeeType: 'Payee Type',
  payeeUserId: 'Payee UserId',
  payeeVpa: 'Payee Vpa',
  payerBankId: 'Payer BankId',
  binList: 'Bin List',
  binRange: 'Bin Range',
  cardType: 'card Type',
  scheme: 'Scheme',
  amount: 'Amount',
  transactionInitiatingEntityId: 'Entity ID',
  transactionApplication: 'Transaction Application',
  txntype: 'Transaction type',
  instrumentType: 'Instrument Type',
  mode: 'Mode',
  activationGroup: 'Activation Group',
  priority: 'Priority',
  processor: 'Processor',
  isActive: 'Status',
}

export const mimeTypes = new Map([
  ['application/vnd.ms-excel', '.xls'],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.xlsx'],
  ['application/pdf', '.pdf'],
  ['text/csv', '.csv'],
  ['text/plain', '.txt'],
  ['application/text', '.txt'],
  ['application/octet-stream', '.csv'],
  ['application/zip', '.zip'],
  ['image/jpg', '.jpg'],
  ['image/jpeg', '.jpeg'],
  ['image/png', '.png'],
])

export const FORM_MESSAGE = 'FORM_MESSAGE'

export const PAYMENT_MODE_SUBTYPES = {
  UPI: 566,
  NB: 581,
  CARD: 582,
  WALLET: 579,
  CARDLESS_EMI: 600,
  EMI: 114, //TYPE
  PAYLATER: 601,
  FOOD_CARD: 613,
  CORP_NB: 620,
}

export const bulkEntityStringConstants: any = {
  bulkUpload: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Entities',
    fileUploadTitle: 'Upload your bulk creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded entity data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Entity Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  tid: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Sync Bulk Entities with MAS',
    fileUploadTitle: 'Upload your bulk sync excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded entity data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Syncing with MAS',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  retryEntityCreation: {
    retryingCreation: 'Please wait, we are processing your request...',
  },
  bulkConfig: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Config',
    fileUploadTitle: 'Upload your bulk config creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded config data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Config Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  bulkCard: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Cards',
    fileUploadTitle: 'Upload your bulk card creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded cards data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Card Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  bulkVpa: {
    headerTitle: 'Content of File : ',
    createBulkEntity: "Create Bulk Vpa's",
    fileUploadTitle: "Upload your bulk vpa's creation excel file",
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded vpa data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: "Submit File for Bulk Vpa's Creation",
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  bulkStore: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk Store Onboarding',
    fileUploadTitle: 'Upload your bulk store creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded store data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Store Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  bulkTerminal: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk Terminal Onboarding',
    fileUploadTitle: 'Upload your bulk terminal creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded vpa data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Terminal Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
  },
  MCC_EXPORT: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk MCC Lov',
    fileUploadTitle: 'Upload your bulk MCC Lov creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded MCC data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk MCC Lov Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  IFSC_EXPORT: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk IFSC Lov',
    fileUploadTitle: 'Upload your bulk IFSC Lov creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded IFSC data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk IFSC Lov Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  PINCODE_EXPORT: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk PINCODE Lov',
    fileUploadTitle: 'Upload your bulk PINCODE Lov creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded PINCODE data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk PINCODE Lov Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  PROGRAM_CATEGORY_EXPORT: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Program Category Lov',
    fileUploadTitle: 'Upload your bulk Program Category Lov creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Program Category data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Program Category Lov Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BULK_STORE_UPDATE: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Store Update',
    fileUploadTitle: 'Upload your bulk Store Update creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Bulk Store Update data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Store Update Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BULK_DEVICES: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Device Update',
    fileUploadTitle: 'Upload your bulk Device Update creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Device Update data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Device Update Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BULK_TERMINAL_UPDATE: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Terminal Update',
    fileUploadTitle: 'Upload your  Bulk Terminal Update creation excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the Bulk Terminal Update data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Terminal Update',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  ADD_MERCHANT_MAPPING: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Upsert Bulk Merchant Mapping',
    fileUploadTitle: 'Upload your Upsert Bulk Merchant Mapping excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded  file',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Merchant Mapping Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BULK_KEY_EXCHANGE_UPLOAD: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk Key Exchange',
    fileUploadTitle: 'Upload your Bulk Key Exchange excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded  file',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Key Exchange',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  APPROVE_MERCHANT_MAPPING: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk Merchant Mapping Approval Upload',
    fileUploadTitle: 'Upload your bulk Batch Approval excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Merchant Mapping data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Merchant Mapping  Aprrovals',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BATCH_MAKER: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk POS Batch Upload - Maker',
    fileUploadTitle: 'Upload File',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Pos Batch data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Batch Creation',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BATCH_CHECKER: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Bulk POS Batch Upload - Checker',
    fileUploadTitle: 'Upload File',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Batch Approva data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Batch Approval',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  BULK_USER_MANAGEMENT: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Onboard Users Upload',
    fileUploadTitle: 'Upload your Bulk Onboard Users excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Bulk Onboard Users  data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Onboard Users ',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  CHECKER_1_BULK_CLAIM: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Checker 1 claim Upload',
    fileUploadTitle: 'Upload your Checker 1  claim excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Checker 1 claim  data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Checker 1 claim ',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  CHECKER_2_BULK_CLAIM: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Checker 2 claim Upload',
    fileUploadTitle: 'Upload your Checker 2 claim excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Checker 2 claim  data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Checker 2 claim ',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  CHECKER_1_BULK_ACTION: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Checker 1 Action Upload',
    fileUploadTitle: 'Upload your Bulk Checker 1 Action excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Bulk Checker 1 Action  data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Checker 1 Action ',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
  CHECKER_2_BULK_ACTION: {
    headerTitle: 'Content of File : ',
    createBulkEntity: 'Create Bulk Checker 2 Action Upload',
    fileUploadTitle: 'Upload your Bulk Checker 2 Action excel file',
    dropTextTitle: 'Drop your excel file here',
    reviewUploadedFile: 'Please review the uploaded Bulk Checker 2 Action  data',
    showPreview: 'Showing preview of the uploaded file - ',
    uploadNewFile: 'Upload a new file',
    submitFile: 'Submit File for Bulk Checker 2 Action',
    submittingFileLoaderText: 'Please wait, we are submitting the file for processing..',
    reSubmitLoaderText: 'Please wait, we are re-submitting the file for processing..',
    uploadFileDetails: 'Uploaded File Details',
    fileContent: 'File content',
    done: 'Done',
    failedEntry: 'Failed Entries',
    fileHistoryUploadDetails: 'Uploaded Files History',
    sucessStatusText: 'Your application is submitted',
  },
}

export const getCardSchemaFromName = (name: string) => {
  const map: any = {
    VISA: '104',
    MASTER: '105',
    RuPay: '199',
    Diners: '107',
    Amex: '103',
    CUP: '133',
    Discover: '108',
    EuroPay: '106',
    JCB: '109',
    DINA: '120',
    RPSL: '121',
    FDC: '122',
  }
  return map[name]
}

export const isValidUrl = (urlString: string) => {
  var urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}

export const tableItemStrings = {
  action: 'action',
  checkbox: 'checkbox',
  success: 'SUCCESS',
  id: 'id',
  links: 'links',
  download: 'Download',
  loading: 'loading',
  applicationId: 'id',
  link: ['jioLinkId', 'subscriptionId', 'cId', 'id', 'ID', 'merchantId', 'entity_id', 'docId', 'applicationId'],
  DELETE: 'DELETE',
  deleteCaps: 'DELETE',
}

export const getHeaderTitle = (title: string) => {
  const titleMap: any = {
    date: 'Txn Date',
    ERN: 'Merchant Ref No',
    RRN: 'Jio Txn Id',
    totalAmount: 'Txn Amt',
    transactionStatus: 'Txn Status',
    paymentMode: 'Payment Mode',
    paymentType: 'Payment Type',
    bankRefNo: 'Bank Ref No',
    transactionType: 'Txn Type',
    settlementRefNo: 'Settlement Ref No.',
    accountNumber: 'Account Number',
    refundAmount: 'Refund Amt',
    authCode: 'Auth Code',
    acquirerTerminal: 'Terminal Id',
    surCharge: 'Surcharge Amt',
    convenienceFeeAmount: 'Convenience Fee Amt', // Commented as per request from Santosh and Sujit to remove from FE
    emiCode: 'EMI Code', // Commented as per request from Santosh and Sujit to remove from FE
    merchantName: 'Merchant Name',
    merchantType: 'Merchant Type',
    settlementStatus: 'Settlement Status',
    settledAmount: 'Settled Amount',
    chargeBackReason: 'Chargeback Code', // Commented as per request from Santosh and Sujit to remove from FE
    refundStatus: 'Refund Status',
    settlementDate: 'Settlement Date',
    customerId: 'Customer Id',
    customerName: 'Customer Name',
    mobileNumber: 'Mobile No.',
    email: 'Email',
    offerTransactionAmount: 'Offer Txn Amount',
    cashBackAmount: 'Cashback Amount',
    instantDiscountAmount: 'Instant Discount Amt',
    offerCode: 'Offer Code',
    offerReferenceId: 'Offer Ref ID',
    failureReason: 'Failure Reason',
  }
  return titleMap[title] ?? title
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    check: 30,
    fromDate: 200,
    toDate: 200,
    date: 200,
    startDate: 120,
    endDate: 120,
    requestType: 100,
    id: 50,
    mid: 80,
    actionDownload: 40,
    applicationId: 300,
    mobileNumber: 100,
    creationDate: 200,
    actionHoldRelease: 40,
    auditType: 50,
    assignee: 100,
    createdAt: 100,
    createdBy: 100,
    makerComments: 50,
    comments: 50,
    releaseAmount: 200,
    postReconDate: 50,
    settlementGrossAmount: 50,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export const getPosCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    check: 80,
    id: 60,
    // processingEntity: 10,
    // bankName: 120,
    mid: 180,
    tid: 120,
    emsBusinessCategory: 280,
    emsBusinessName: 240,
    emsBankEntityId: 180,
    emsBankTerminalId: 180,
    // createdAt: 160,
    // eecCreatedAt: 160,
  }
  console.log('columnKey::', columnKey)
  return columnsKeyWidth[columnKey] ?? 150
}

export const checkDropdownData = [
  { id: '1', value: 'Approved' },
  { id: '2', value: 'Rejected' },
]

export const approveDropdownData = [{ id: '1', value: 'Approve' }]
export const checkerHeaderTitles = {
  check: '',
  applicationId: 'Application ID',
  businessName: 'Business Name',
  assignee: 'Assigned To User',
  creationDate: 'Creation Date & Time',
  mobileNumber: 'Primary Mobile No.',
  requestType: 'Request Type',
  applicationStatus: 'Status',
}

export const fiuCheckerHeaderTitles = {
  applicationId: 'Application ID',
  auditType: 'Audit Type',
  createdAt: 'Creation Date & Time',
  createdBy: 'Created By',
  applicationStatus: 'Status',
}

export const makerHeaderTitles = {
  applicationId: 'Application ID',
  businessName: 'Business Name',
  identificationNumber: 'Identification Number',
  creationDate: 'Creation Date & Time',
  mobileNumber: 'Primary Mobile No.',
  requestType: 'Request Type',
  status: 'Status',
}

export const myQueueHeaderTitles = {
  applicationId: 'Application ID',
  businessName: 'Business Name',
  creationDate: 'Creation Date & Time',
  mobileNumber: 'Primary Mobile No.',
  requestType: 'Request Type',
  applicationStatus: 'Status',
}
const getDateValue = (dateValue: number): Date => {
  const today = new Date(Date.now())
  return new Date(today.setDate(today.getDate() - dateValue))
}

const getTodayValue = (): Date => {
  const today = new Date(Date.now())
  return new Date(today.setHours(0, 0, 0, 0))
}

const getLastHourValue = (): Date => {
  const today = new Date(Date.now())
  return new Date(today.getTime() - 1000 * 60 * 60)
}

export const getSelectedDate = (type: number): Date => {
  const getSelectedValue: any = {
    0: getLastHourValue(),
    1: getTodayValue(),
    2: getDateValue(7),
    3: getDateValue(30),
    4: getDateValue(90),
    5: getDateValue(3),
  }
  return getSelectedValue[type]
}

export const controlsData = [
  { id: '1', value: 'ESS_MID_SPECIFIC', key: 'ESS_MID_SPECIFIC ' },
  { id: '2', value: 'ESS_MID_SPECIFIC_AND_MAS_ONLY_PAYOUT', key: 'ESS_MID_SPECIFIC_AND_MAS_ONLY_PAYOUT' },
  { id: '3', value: 'MAS_AND_ESS', key: 'MAS_AND_ESS' },
  { id: '3', value: 'MAS_ONLY', key: 'MAS_ONLY' },
  { id: '3', value: 'ESS_ONLY', key: 'ESS_ONLY' },
]

export const ROUTING_PACKAGE_FILETYPE = 0
export const MDR_FEE_PACKAGE_FILETYPE = 1

export const integrationMethods = [
  { id: 1, value: 'SFTP' },
  { id: 2, value: 'API' },
]

export const accountTypeArr = [
  { id: 101, value: 'Savings' },
  { id: 102, value: 'Current' },
  { id: 103, value: 'Overdraft' },
]
export const ENABLE_DUMMY_OWN_CHANNEL_ID = false

export const posApprovalHeadTitles = [
  { check: 'Select' },
  { id: 'Id' },
  { processingEntity: 'Processing Entity' },
  { bankName: 'Bank Name' },
  { mid: 'Entity Id' },
  { tid: 'Terminal Id' },
  { emsBusinessCategory: 'Category' },
  { emsBusinessName: 'Name' },
  { emsBankEntityId: 'Bank MID' },
  { emsBankTerminalId: 'Bank TID' },
  { createdAt: 'Created At' },
  { eecCreatedAt: 'EEC Created At' },
]
export const posApprovedHeadTitles = [
  { id: 'Id' },
  { processingEntity: 'Processing Entity' },
  { bankName: 'Bank Name' },
  { mid: 'Entity Id' },
  { tid: 'Terminal Id' },
  { emsBusinessCategory: 'Category' },
  { emsBusinessName: 'Name' },
  { emsBankEntityId: 'Bank MID' },
  { emsBankTerminalId: 'Bank TID' },
  { createdAt: 'Created At' },
  { eecCreatedAt: 'EEC Created At' },
]
export const pageSizeList = [
  { id: 1, value: '10' },
  { id: 2, value: '20' },
  { id: 3, value: '50' },
  { id: 4, value: '100' },
]

export const posStatusList = [
  { id: 1, value: 'REQUEST_CREATED' },
  { id: 2, value: 'REQUEST_SENT' },
  { id: 3, value: 'APPROVED' },
  { id: 4, value: 'REJECTED' },
  { id: 5, value: 'RESPONSE_RECIEVED' },
  { id: 6, value: 'RESPONSE_UNMATCHED' },
  { id: 7, value: 'ALREADY_ONBOARDED' },
]

export const aadharCheckerHeaderTitles = {
  applicationId: 'Application ID',
  identificationNumber: 'MID',
  createdAt: 'Creation Date & Time',
  applicationStatus: 'Status',
  createdBy: 'Maker',
  makerComments: 'Maker Comments',
  comments: 'Checker Comments',
  action: 'Actions',
}

export const aadharCheckerMakerTitles = {
  applicationId: 'Application ID',
  identificationNumber: 'MID',
  createdAt: 'Creation Date & Time',
  applicationStatus: 'Status',
  createdBy: 'Maker',
  makerComments: 'Maker Comments',
  comments: 'Checker Comments',
}

export const postReconHeaders = {
  check: '',
  postReconDate: 'Date',
  releaseAmount: 'Release Amount',
  actionDownload: 'Action',
}

export const STORE_MERCHANT = 'STORE_MERCHANT'

export const MIN_HEIGHT_FOR_NO_ZOOM = 800

export const ZOOM_FRACTION = 0.8

export const ZOOM_PERCENTAGE = `${ZOOM_FRACTION * 100}%`
